/**
 * @generated SignedSource<<81787aff30f34c5214c2d0e7081e770d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConnectConfigUpdateInput = {
  setColor?: string | null;
  setCustomerIndexSiteActive?: boolean | null;
  setCustomerIndexSiteWelcomeMessage?: string | null;
  setEmail?: string | null;
  setFacebookLink?: string | null;
  setInstagramLink?: string | null;
  setPhoneNumber?: string | null;
};
export type ConnectAdminSiteAdminSaveMutation$variables = {
  input: ConnectConfigUpdateInput;
};
export type ConnectAdminSiteAdminSaveMutation$data = {
  readonly store: {
    readonly updateConnectConfig: {
      readonly store: {
        readonly connectConfig: {
          readonly color: string | null;
          readonly email: string | null;
          readonly facebookLink: string | null;
          readonly instagramLink: string | null;
          readonly phoneNumber: string | null;
          readonly site: {
            readonly active: boolean | null;
            readonly publicUrl: string | null;
            readonly qrCode: {
              readonly svg: string | null;
            } | null;
            readonly welcomeMessage: string | null;
          } | null;
        } | null;
      } | null;
    };
  };
};
export type ConnectAdminSiteAdminSaveMutation = {
  response: ConnectAdminSiteAdminSaveMutation$data;
  variables: ConnectAdminSiteAdminSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ConnectConfig",
  "kind": "LinkedField",
  "name": "connectConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConnectConfigSite",
      "kind": "LinkedField",
      "name": "site",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "welcomeMessage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QRCode",
          "kind": "LinkedField",
          "name": "qrCode",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "svg",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectAdminSiteAdminSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UpdateConnectConfigPayload",
            "kind": "LinkedField",
            "name": "updateConnectConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectAdminSiteAdminSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UpdateConnectConfigPayload",
            "kind": "LinkedField",
            "name": "updateConnectConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2eaa7a1e8e314c747ccc672e185a15cb",
    "id": null,
    "metadata": {},
    "name": "ConnectAdminSiteAdminSaveMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectAdminSiteAdminSaveMutation(\n  $input: ConnectConfigUpdateInput!\n) {\n  store {\n    updateConnectConfig(input: $input) {\n      store {\n        connectConfig {\n          color\n          email\n          phoneNumber\n          facebookLink\n          instagramLink\n          site {\n            active\n            publicUrl\n            welcomeMessage\n            qrCode {\n              svg\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ba5229c45ae97974e0d449419d5220a";

export default node;
